import { Component, OnInit, NgZone, OnDestroy, Input, Output, EventEmitter } from '@angular/core';
import { ControlPosition, MapTypeControlOptions, MapsAPILoader, MouseEvent } from '@agm/core';
import { Observable } from 'rxjs';
import { reduce, takeUntil } from 'rxjs/operators';
import { componentDestroyed } from '@w11k/ngx-componentdestroyed';
import { LatLngLiteral } from '@agm/core';
import { SharedDataService } from 'src/app/service/shared-service/shared-data.service';
import { environment } from 'src/environments/environment';
import { CsvService } from 'src/app/service/csv-service/csv.service';
import * as moment from 'moment';
import { AssigTripsService } from 'src/app/component/assigned-trips/assigntrips-service/assigntrips-service';
import { CorporateService } from 'src/app/component/corporate-user/corporate-service/corporate-service';
import { DispatchCenterService } from 'src/app/component/dashboard/dashboard-service/dispatch-center-service';
import { LevelOfServiceService } from 'src/app/component/level-of-service/service/level-of-service.service';
import { sweetAlert } from 'src/app/utils/swal';
import { checkRole } from 'src/app/utils/utils.common';
import { UserRoles } from 'src/app/component/shared/layout/menu-service/menu.service';
import { DriversService } from 'src/app/component/drivers/drivers-service/drivers-service';
import { FeedbackService } from 'src/app/service/feedback/feedback.service';
import { AuthService } from 'src/app/service/auth-service/auth.service';
import { MemberService } from 'src/app/component/members/member-service/member.service';

@Component({
  selector: 'app-trip-details',
  templateUrl: './trip-details.component.html',
  styleUrls: ['./trip-details.component.css']
})
export class TripDetailsComponent implements OnInit, OnDestroy {
  @Input() tripId: any
  @Input() prePayorsList: any;
  @Input() openFrom?: any
  @Output() onCloseModal = new EventEmitter<any>();
  address: string;
  zoom: number;
  jobId;
  trackinURL;
  tripDetails = null;
  jobAcceptedUrl = null;
  jobOnSceneUrl = null;
  jobStartedUrl = null;
  jobEndedUrl = null;
  jobFinishedUrl = null;
  jobCancelledUrl = null;
  mapTypeControlOptions: MapTypeControlOptions = {
    position: ControlPosition.TOP_LEFT
  };
  isDrawRoute = false;
  origin = { lat: 0.00000, lng: 0.00000 };
  destination = { lat: 0.00000, lng: 0.00000 };
  assign;
  cameraImages;
  user;
  tripAssistance: {
    displayName: '',
    contactNumber: ''
  };
  contact
  timeZone
  todayDate = [];
  isAllowRates = false;
  feedback: any;
  // assistedDriver;
  checkListObj: any = null;
  constructor(
    private feedbackService: FeedbackService,
    private driverService: DriversService,
    private levelOfServiceService: LevelOfServiceService,
    private corporateService: CorporateService,
    private dispatchCenterService: DispatchCenterService,
    private assigTripsService: AssigTripsService,
    private sharedDataService: SharedDataService,
    private csvService: CsvService,
    private authService: AuthService,
    private memberService: MemberService
  ) { }

  ngOnInit() {
    this.getFeedbackById();
    this.trackinURL = environment.TRACKING_URL+'trip-tracking/';
    this.jobId = this.tripId;
    this.sharedDataService
      .getUser()
      .pipe(takeUntil(componentDestroyed(this)))
      .subscribe(user => {
        if (user) {
          this.user = user;
          this.timeZone = user.timeZone;
          this.todayDate = [
            moment.tz(this.timeZone).startOf("day").toISOString(),
            moment.tz(this.timeZone).endOf("day").toISOString(),
          ];

          this.getCompletedTripDetail();
          this.isAllowRates = checkRole(this.user);
        }
      });
  }

  twodigit(val) {
    return parseFloat(parseFloat(val).toFixed(2));
  }

  closeDetailModal() {
    this.onCloseModal.emit();
  }

  breakString(str) {
    if (!str) return "";
    return str.replace(/\n/g, "<br>");
  }

  isStringExist(substrings, str) {
    if (substrings.some(v => str.toLowerCase().includes(v))) {
      return true;
    }
    return false;
  }

  private async confirmSmsConsent(displayName: string): Promise<boolean> {
    const memberId = (this.tripDetails.priorityClient && this.tripDetails.priorityClient._id) || this.tripDetails.client;
    if (!memberId) return true;

    const member = await this.memberService.getMemberById(memberId).toPromise();
    if (member && member.smsConsent === false) {
      const confirm = await sweetAlert(
        'Alert',
        `${displayName} has not given consent to receive SMS messages. Are you sure you want to send this message anyway?`,
        'warning',
        'Yes, Send Anyway',
        'Cancel'
      );
      return !!(confirm && confirm.value);
    }
    return true;
  }

  async sendSMS() {
    if (!this.tripAssistance.displayName || !this.tripAssistance.contactNumber) return;

    const canSend = await this.confirmSmsConsent(this.tripAssistance.displayName);
    if (!canSend) return;

    this.assigTripsService
      .sendTripAssistanceSMS(this.tripDetails._id, this.tripAssistance)
      .pipe(takeUntil(componentDestroyed(this)))
      .subscribe(data => {
        if (data) {
          if (data.success) {
            sweetAlert('Success', data.message + ' ' + data.link, 'success', 'OK');
          } else {
            sweetAlert('Error', data.message, 'error', 'OK');
          }
        }
      });
  }

  async sendTrackingSMS() {
    const canSend = await this.confirmSmsConsent(this.tripDetails.priorityClient.displayName);
    if (!canSend) return;

    const payload = {
      ...this.tripDetails,
      tripId: this.tripDetails._id,
      latitude: this.tripDetails.driver.latitude,
      longitude: this.tripDetails.driver.longitude,
      contactNumber: this.tripDetails.priorityClient.contactNumber
    }
    this.assigTripsService
      .sendTrackingSMS(payload)
      .pipe(takeUntil(componentDestroyed(this)))
      .subscribe(data => {
        if (data) {
          // this.contact = '';
          if (data.success) {
            sweetAlert('Success', data.message, 'success', 'OK');
          } else {
            sweetAlert('Error', data.message, 'error', 'OK');
          }
        }
      });
  }

  getCompletedTripDetail() {
    this.dispatchCenterService.getTripDetail(this.jobId).subscribe(async (data) => {
      if (data) {
        this.tripDetails = data;

        // if(this.tripDetails.attendees){
        //   this.getAssistByid(this.tripDetails.attendees);
        // }

        this.tripAssistance = {
          displayName: this.tripDetails.priorityClient.displayName,
          contactNumber: this.tripDetails.priorityClient.contactNumber
        };


        if (this.tripDetails.job && this.tripDetails.job.trackInfoJob) {

          if (this.tripDetails.job.trackInfoJob.jobAccepted)
            this.jobAcceptedUrl = await this.loadStaticMap(this.tripDetails.job.trackInfoJob.jobAccepted.coords[1],
              this.tripDetails.job.trackInfoJob.jobAccepted.coords[0]);

          if (this.tripDetails.job.trackInfoJob.jobArrived)
            this.jobOnSceneUrl = await this.loadStaticMap(this.tripDetails.job.trackInfoJob.jobArrived.coords[1],
              this.tripDetails.job.trackInfoJob.jobArrived.coords[0]);

          if (this.tripDetails.job.trackInfoJob.jobStarted)
            this.jobStartedUrl = await this.loadStaticMap(this.tripDetails.job.trackInfoJob.jobStarted.coords[1],
              this.tripDetails.job.trackInfoJob.jobStarted.coords[0]);

          if (this.tripDetails.job.trackInfoJob.jobCompleted)
            this.jobEndedUrl = await this.loadStaticMap(this.tripDetails.job.trackInfoJob.jobCompleted.coords[1],
              this.tripDetails.job.trackInfoJob.jobCompleted.coords[0]);

          if (this.tripDetails.job.trackInfoJob.jobFinished)
            this.jobFinishedUrl = await this.loadStaticMap(this.tripDetails.job.trackInfoJob.jobFinished.coords[1],
              this.tripDetails.job.trackInfoJob.jobFinished.coords[0]);

          if (this.tripDetails.job.trackInfoJob.jobCancelled)
            this.jobCancelledUrl = await this.loadStaticMap(this.tripDetails.job.trackInfoJob.jobCancelled.coords[1],
              this.tripDetails.job.trackInfoJob.jobCancelled.coords[0]);
        }

        this.origin = {
          lat: this.tripDetails.jobOriginLatitude,
          lng: this.tripDetails.jobOriginLongitude
        };
        this.destination = {
          lat: this.tripDetails.jobDestinationLatitude,
          lng: this.tripDetails.jobDestinationLongitude
        };
        this.getCorporateUserById();
        this.getLevelOfServicebyId();
        this.getSpaceTypesbyId();
      }
    })
  }

  getCorporateUserById() {
    this.corporateService.getCorporateUserById(this.tripDetails.cooperate)
      .pipe(takeUntil(componentDestroyed(this)))
      .subscribe((data) => {
        if (data) {
          this.tripDetails.cooperate = data.displayName
          this.contact = data.contactNumber
        }


      });
  }

  getLevelOfServicebyId(){
    this.levelOfServiceService.getLevelOfServicebyId(this.tripDetails.los)
      .pipe(takeUntil(componentDestroyed(this)))
      .subscribe(
        (data) => {
          if (data) {
            this.tripDetails.los = data.title
          }
        },

      );
  }

  getSpaceTypesbyId() {
    this.levelOfServiceService.getServiceTypebyId(this.tripDetails.spaceType)
      .pipe(takeUntil(componentDestroyed(this)))
      .subscribe(
        (data) => {
          if (data) {
            this.tripDetails.spaceType = data.title
          }
        },

      );
  }

  // getAssistByid(assistId) {
  //   this.driverService
  //     .getDriversByID(assistId)
  //     .pipe(takeUntil(componentDestroyed(this)))
  //     .subscribe(data => {
  //       if (data) {
  //         this.assistedDriver = data;
  //         console.log('assistedDriver', this.assistedDriver);
  //       }
  //     });
  // }

  getFeedbackById() {
    this.feedbackService.getFeedbackById(this.tripId)
      .pipe(takeUntil(componentDestroyed(this)))
      .subscribe(
        (data) => {
          if (data) {
            this.feedback = data;
          }
        },

      );
  }

  loadStaticMap = async (lat, lng) => {
    let mapKey = '';
    const res = await this.authService.getGoogleKeys().toPromise();
    if (res && res.key) {
      console.log('Load static map API key:');
      mapKey = res.key;
    } else {
      console.error('Error load static map API key');
    }
    let url = 'https://maps.googleapis.com/maps/api/staticmap?center='
      + lat + ',' + lng + '&zoom=18&size=500x500&maptype=satellite&markers=color:red|' + lat
      + ',' + lng + '&key=' + mapKey;

    return url;
  }

  checkListModal(assign) {
    this.checkListObj = assign;
  }

  ngOnDestroy(): void {
  }

}
